/* eslint-disable max-len */
import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing an unknown trip icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <UnknownTripIcon width={12} />
 */
const UnknownTripIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M13.092 16.419v-0.368c0-2.109 1.868-2.62
            1.868-4.219 0-0.895-0.601-1.439-1.592-1.439-0.844 0-1.332 0.272-1.705
            0.48l-0.099-1.597c0.439-0.176 1.236-0.416 2.193-0.416 1.819 0 3.216
            0.799 3.216 2.669 0 2.109-2.208 2.86-2.208 4.601v0.288h-1.673zM12.995
            19.679v-2.109h1.868v2.109h-1.868z`}
        />
        <path d="M16.928 21.232v0l0.001-0.003z" />
        <path
            d={`M27.848
            21.041c-0.168-0.143-0.277-0.236-0.375-0.511-0.001-0.004-0.567-1.744-1.044-3.132-0.355-1.033-0.895-1.399-2.063-1.399h-5.229c-1.169
            0-1.708 0.365-2.063 1.399-0.476 1.388-1.043 3.128-1.044 3.132-0.099
            0.275-0.208 0.369-0.375 0.511-0.384 0.328-0.701 0.687-0.701 1.756v4.705c0
            0.575 0.471 1.045 1.045 1.045h1.045c0.576 0 1.047-0.471
            1.047-1.045v-1.045h7.32v1.045c0 0.575 0.471 1.045 1.045 1.045h1.047c0.575
            0 1.045-0.471 1.045-1.045v-4.705c0-1.069-0.319-1.428-0.701-1.756zM17.045
            24.367c-0.577 0-1.045-0.468-1.045-1.045 0-0.579 0.468-1.047 1.045-1.047
             0.579 0 1.047 0.468 1.047 1.047 0 0.577-0.468 1.045-1.047 1.045zM23.843
             25.412h-4.183c-0.288 0-0.523-0.236-0.523-0.523 0-0.288 0.236-0.523
             0.523-0.523h4.183c0.288 0 0.523 0.235 0.523 0.523 0.001 0.287-0.235
             0.523-0.523 0.523zM16.892 21.229c0 0 0.881-2.689 1.16-3.493 0.185-0.536
             0.273-0.689 1.077-0.689h5.245c0.803 0 0.892 0.155 1.077 0.689 0.279
             0.804 1.16 3.493 1.16 3.493h-9.72zM26.457 24.367c-0.577
             0-1.045-0.468-1.045-1.045 0-0.579 0.468-1.047 1.045-1.047 0.579 0
             1.047 0.468 1.047 1.047 0 0.577-0.468 1.045-1.047 1.045z`}
        />
        <path
            d={`M13.916 22.915c-4.612-0.187-8.311-3.988-8.311-8.645
            0-4.777 3.887-8.664 8.664-8.664s8.664 3.887 8.664 8.664c0 0.233-0.017
            0.463-0.036 0.692h1.469c0.248 0 0.475 0.021 0.692 0.052 0.017-0.245
            0.029-0.493 0.029-0.744 0-5.965-4.853-10.819-10.819-10.819s-10.819
            4.853-10.819 10.819c0 5.847 4.663 10.621 10.465 10.809v-2.164z`}
        />
    </SvgIcon>
)

UnknownTripIcon.defaultProps = defaultProps

export { UnknownTripIcon }
